module.exports = __webpack_public_path__ + "static/media/Ingredient2024_en.063320c0.png";